<template>
  <div class='table-box'>
    <QueryForm
      @QuerySearch='QuerySearch'
      :queryForm='queryForm'
      :typeN="2"
    ></QueryForm>
    <div
      class='map_right'
      id='container'
    ></div>
    <!-- 弹窗 end -->
    <shipingtonghua
      v-if="videoModal"
      :userId="userId"
      :closeSP.sync="videoModal"
    ></shipingtonghua>
  </div>
</template>

<script>
import request from '@/utils/request'
import QueryForm from '@/component/queryform4.vue'

export default {
  components: {
    QueryForm,
  },
  data() {
    return {
      map: null,
      markers: [],
      queryForm: {
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        communityId: '',
        address: ''
      },
      videoModal: false,
      userId: ''
    }
  },
  mounted() {
    this.mapInit()
  },
  methods: {
    QuerySearch() {
      if(this.map) {
        this.map.clearMap()
      }
      this.getPerson()
    },
    //加载地图
    mapInit() {
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map('container', {
          resizeEnable: true,
          zoom: 18
        })
        this.map.on('complete', () => {
          this.getPerson()
          resolve()
        })
      })
    },
    //服务人员
    getPerson() {
      request({
        url: 'jjyl/admin/center/customer/info/findList',
        method: 'POST',
        data: {
          ...this.queryForm,
          pageNo: 1,
          pageSize: 10000,
        }
      }).then((res) => {
        if (res.code == 200) {
          let personList=[]
          if(res.content && res.content !==null){
            personList = res.content.list || []
            personList.forEach(item => {
            const icon = new AMap.Icon({
              image: require('@/assets/img/map/serviceUser.png'),
              imageSize: new AMap.Size(22, 30)
              // imageOffset: new AMap.Pixel(-95, -3)
            })
            const marker = new AMap.Marker({
              map: this.map,
              icon: icon,
              // position: [116.473188, 39.993253]
              position: [
                Number(item.longitude),
                Number(item.latitude),
              ],
            })
            this.markers.push(marker)

            marker.on('click', e => {
              const content = `<div class='map-modal' style='width: 300px'>
                                <p>姓名：${item.customerName}</p>
                                <p class='m-t10'>电话：${item.phone}</p>
                                <p class='m-t10'>地址：${item.address}</p>
                              </div>`

              const infowindow = new AMap.InfoWindow({
                content: content,
                offset: new AMap.Pixel(0, -30)
              })
              infowindow.open(this.map, [
                Number(item.longitude),
                Number(item.latitude),
              ])
            })
          })
          this.map.setFitView(this.markers)
          }
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
#container {
  width: 100%;
  height: calc(100vh - 200px);
}

/deep/ .map-modal {
  button {
    cursor: pointer;
    color: #fff;
    background-color: #409eff;
    border: none;
    padding: 5px 10px;
  }
}
</style>
